let socket = null; // 连接对象
let linkFailCount = 0; // 连接次数，目前连接三次
let relinkLoading = null;// 重连全屏loading
let heartbeatTimer = null;
let socketUrl = '';

import { ElMessageBox, ElLoading } from 'element-plus'
import { getToken } from '@/utils/auth'
 
/**
 * @description: 初始化websocket
 * @param {*} linkUrl url的地址
 * @return {WebSocket} WebSocket对象
 * @Author: liuxin
 */
function initWebSocket(linkUrl = "") {
    // 正在连接或连接成功
    if (socket && (socket.readyState < 2)) {
        return socket;
    }
    // 如果地址由上层传递过来，则使用传递的地址
    if (linkUrl) {
        socketUrl = linkUrl
    }
    const url = socketUrl;
    socket = new WebSocket(url+`?token=${getToken()}`) // 创建对象
    socket.onerror = webSocketOnError; // 连接错误处理
    socket.onclose = closeWebsocket; // 连接关闭处理
    socket.onopen = openWebsocket; // 连接打开处理
    sendHeartBeat()
    return socket;
}

function sendHeartBeat() {
    heartbeatTimer = setInterval(() => {
        let obj = {
            heartbeat: true
        }
        sendMessage(obj)
    },100000)
}

/**
 * @description: 打开websocket回调函数处理
 * @return {*}
 * @Author: liuxin
 */
function openWebsocket() {
    console.log("WebSocket连接打开...");
    linkFailCount = 0;// 打开连接，连接次数改为0
    // 加载动画如果开启，则关闭
    if (relinkLoading) {
        relinkLoading.close();
    }
}

/**
 * @description: 关闭websocket回调函数处理
 * @return {*}
 * @Author: liuxin
 */
function closeWebsocket(event) {
    console.log(event)
    // 连接关闭时，立刻开启重连机制
    if (linkFailCount < 3 && socket && (socket.readyState >= 2)) {
        // 开启重连加载动画
        relinkLoading = ElLoading.service({
            lock: true,
            text: `连接关闭了，正在重连，请稍等...`,
        })
        initWebSocket();
    }
}

/**
 * @description: 连接错误回调函数处理
 * @param {*} e 错误对象
 * @Author: liuxin
 */
function webSocketOnError(e) {
    linkFailCount++;// 连接失败的次数
    if (relinkLoading) {
        relinkLoading.close(); // 关闭重连加载动画
    }
    //连接三次
    if (linkFailCount < 3) {
        initWebSocket();
        // 开启重连加载动画
        relinkLoading = ElLoading.service({
            lock: true,
            text: `第${linkFailCount}次连接失败，正在尝试第${linkFailCount + 1}次重新连接，请稍等...`,
        })
    } else {
        ElMessageBox.confirm(
            '连接失败，是否尝试刷新？',
            '警告',
            {
                confirmButtonText: '刷新',
                cancelButtonText: '取消',
                type: 'warning',
                "close-on-click-modal": false
            }
        )
            .then((e) => {
                if (e == "confirm") {
                    location.reload();
                }
            })
    }
}

/**
 * @description: 发送websocket数据给后端
 * @param {String} method 方法
 * @param {JSON} params 参数
 * @return {Object<JSON>} 
 * @Author: liuxin
 */
function sendMessage(params) {
    if (socket && socket.readyState == 1) {
        console.log("sendMessage----------", params);
        socket.send(JSON.stringify(params))
    }
}

function closeConnection() {
    console.log('关闭连接')
    socket.close()
}

export default{
    initWebSocket,
    sendMessage,
    closeConnection
}